import { Icons } from '@shared/components/content/icons';
import { cn } from '@shared/lib/utils';

export function NavCountBadge({ count }: { count: number }) {
  return (
    <div
      className={cn(
        'ml-auto flex size-4 items-center justify-center rounded-full bg-orange-400 text-[10px] font-semibold text-gray-00',
        {
          'w-6': count > 99,
        }
      )}
    >
      {count > 99 ? '99+' : count}
    </div>
  );
}

export function NavImportStatusBadge({ type }: { type: 'loading' | 'error' }) {
  if (type === 'loading') {
    return <Icons.loader2 className="ml-auto size-4 animate-spin !text-teal-500" />;
  }
  return <Icons.warning className="ml-auto size-4 !text-warning-700" />;
}
